<template>
  <div>
    <content-data v-for="(node, idx) in nodes" :key="idx" :node="node" @image-click="openImgModal" />

    <client-only>
      <image-detail-modal
        ref="imageDetailModalRef"
        :images="[clickedImage]"
        :should-hide-pagination-number="true"
        :should-encode-image-path="false"
      />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import ContentData from '@/components/ContentData.vue'

import type { ProductContentElement } from '@/types/api'

interface Props {
  /** 「了解更多」/「購買須知」靜態內容的 tree node 陣列 */
  nodes: ProductContentElement[]
}

const ImageDetailModal = defineAsyncComponent(() => import('@/components/dialog/image-detail-modal.vue'))

withDefaults(defineProps<Props>(), {
  nodes: () => [],
})

const imageDetailModalRef = useTemplateRef<InstanceType<typeof ImageDetailModal>>('imageDetailModalRef')

const clickedImage = ref('')

function openImgModal(imgUrl: string) {
  clickedImage.value = imgUrl
  imageDetailModalRef.value?.showModal()
}
</script>
